import React, { Suspense } from "react";
import LoadingBar from "common/loading";

export default function OurSuspense(props) {
  return <Suspense fallback={<LoadingBar />}>{props.children}</Suspense>;
}
